import { useNavigate } from "react-router";
import { useMutation } from "@tanstack/react-query";
import { useNotification, useTranslate } from "@refinedev/core";

import { ApiError } from "@shared/types";
import { User } from "@modules/users/types/user";
import { CreateUserFormValues } from "@modules/users/validations/createUserSchama";
import { createUserService } from "./service";
import { UseCreateUserMutationOptions } from "./types";

export function useCreateUserMutation(
  options?: UseCreateUserMutationOptions
) {
  const translate = useTranslate();
  const navigate = useNavigate();
  const { open } = useNotification();

  return useMutation<User, ApiError, CreateUserFormValues>({
    mutationFn: createUserService,
    onSuccess: (user: User) => {
      open?.({
        type: "success",
        message: translate("v1/user_admin.success.create"),
      });

      navigate(`/users/edit/${user.id}`);
    },
    onError: (error: ApiError) => {
      open?.({
        type: "error",
        message: error.response.data.error,
      });
    },
    ...options,
  });
}
